// extracted by mini-css-extract-plugin
export default {"triggerStyles":"column_triggerStyles__pBRqS","link":"column_link__X1SZB","triggerChildren":"column_triggerChildren__PbUx4"};